import { render } from "./MobileQrUpload.vue?vue&type=template&id=3d4b0b04&scoped=true"
import script from "./MobileQrUpload.vue?vue&type=script&lang=js"
export * from "./MobileQrUpload.vue?vue&type=script&lang=js"

import "./MobileQrUpload.vue?vue&type=style&index=0&id=3d4b0b04&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4b0b04"]])

export default __exports__